import environment from "@/config/environment";

export default {
    async getHistory(fichaId, token) {
        const url = `${environment.apiUrl}colheita/get-history/${fichaId}`;

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                console.error("Erro ao buscar histórico:", response.status, response.statusText);
                throw new Error("Erro ao buscar histórico. Verifique sua conexão ou tente novamente.");
            }

            const data = await response.json();
            return data.historico || [];

        } catch (error) {
            console.error("Erro ao processar histórico:", error);
            throw new Error(error?.message || "Erro inesperado ao carregar o histórico.");
        }
    },

    async getFicha(fichaId, token) {
        const url = `${environment.apiUrl}colheita/edit/${fichaId}`;

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error("Erro ao buscar ficha. Verifique sua conexão.");
            }

            const data = await response.json();
            const congregado = data.congregado || {};
            const congregacao = data.congregacao || {};

            const formatDate = (dateStr) => {
                if (!dateStr) return "";
                const d = new Date(dateStr.replace(/-/g, '/'));
                const day = String(d.getDate()).padStart(2, '0');
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const year = d.getFullYear();
                return `${day}/${month}/${year}`;
            };

            return {
                // dados do congregado
                nome: congregado.nome || "",
                telefone_celular: congregado.telefone_celular || "",
                tipoDeDecisao: congregado.tipo_decisao || "",
                localDecisao: congregado.local_decisao || "",
                podeSerVisitado: !!congregado.pode_visitar,
                faixaEtaria: congregado.faixa_etaria || "",
                informacoesAdicionais: congregado.informacoes_adicionais || "",

                origem: congregado.origem || "",
                endereco_localizado: !!congregado.endereco_localizado,
                participa_betel: !!congregado.participa_betel,
                sendo_discipulado: !!congregado.sendo_discipulado,

                ebd_inicio: !!congregado.ebd_inicio,
                ebd_conclusao: !!congregado.ebd_conclusao,

                curso_biblico_individual_inicio: !!congregado.curso_biblico_individual_inicio,
                curso_biblico_individual_conclusao: !!congregado.curso_biblico_individual_conclusao,

                curso_biblico_ar_inicio: !!congregado.curso_biblico_ar_inicio,
                curso_biblico_ar_conclusao: !!congregado.curso_biblico_ar_conclusao,

                discipulado_inicio: !!congregado.discipulado_inicio,
                discipulado_conclusao: !!congregado.discipulado_conclusao,

                cep: congregado.cep || "",
                endereco: congregado.endereco || "",
                bairro: congregado.bairro || "",
                numero: congregado.numero || "",
                complemento: congregado.complemento || "",
                cidade: congregado.nome_cidade || "",
                uf: congregado.uf || "",

                dataConversao: formatDate(congregado.data_conversao),
                data_nascimento: formatDate(congregado.data_nascimento),

                ebd_inicio_data: formatDate(congregado.ebd_inicio_data),
                ebd_conclusao_data: formatDate(congregado.ebd_conclusao_data),

                curso_biblico_individual_inicio_data: formatDate(congregado.curso_biblico_individual_inicio_data),
                curso_biblico_individual_conclusao_data: formatDate(congregado.curso_biblico_individual_conclusao_data),

                curso_biblico_ar_inicio_data: formatDate(congregado.curso_biblico_ar_inicio_data),
                curso_biblico_ar_conclusao_data: formatDate(congregado.curso_biblico_ar_conclusao_data),

                discipulado_inicio_data: formatDate(congregado.discipulado_inicio_data),
                discipulado_conclusao_data: formatDate(congregado.discipulado_conclusao_data),

                // dados da congregacao
                campoSelected: congregacao.campo_id || null,
                igrejaSelected: congregacao.igreja_id || null,
                setorSelected: congregacao.setor,
                congregacaoSelected: congregacao.congregacao_id || null,
            };

        } catch (error) {
            console.error("Erro ao buscar ficha:", error);
            throw new Error("Não foi possível carregar a ficha.");
        }
    },
    
    async getNomeObreiro(cpfRol, token) {
        const inputROL = cpfRol?.trim();
        if (!inputROL) return { nome: '' };

        try {
            const params = new URLSearchParams({
                email: 'SEU_EMAIL_AQUI',
                password: 'SUA_SENHA_AQUI',
                congregacao: 'ID_CONGREGACAO'
            }).toString();

            const response = await fetch(`${environment.apiUrl}membros/${inputROL}?${params}`, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    ...(token ? { Authorization: `Bearer ${token}` } : {})
                }
            });

            if (!response.ok) throw new Error('Erro na requisição');

            const result = await response.json();
            const dados = result.response?.dados;

            if (dados && dados.nome) {
                return { nome: dados.nome };
            } else {
                return { nome: 'Não encontramos o obreiro' };
            }
        } catch (error) {
            console.error('Erro ao buscar obreiro:', error);
            return { nome: 'Erro ao buscar obreiro', error };
        }
    },

    async registrarOcorrencia(formData, token) {
        try {
            const response = await fetch(`${environment.apiUrl}colheita/registrar-ocorrencia`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    ...(token ? { Authorization: `Bearer ${token}` } : {})
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (!response.ok) {
                return { success: false, errors: data.errors || {}, message: data.message || 'Erro ao registrar ocorrência.' };
            }

            return { success: true, data };
        } catch (error) {
            console.error('Erro ao registrar ocorrência:', error);
            return { success: false, errors: {}, message: error?.message || 'Erro inesperado ao registrar ocorrência.' };
        }
    }
};
